import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { clearPersistedAuth, loadPersistedAuth, persistAuth } from '../../utils/authStorage';

interface User {
  id: string;
  email: string;
  username: string;
  role: 'STUDENT' | 'TEACHER' | 'ADMIN';
  avatar?: string;
}

interface AuthState {
  user: User | null;
  token: string | null;
  refreshToken: string | null;
  isAuthenticated: boolean;
}

const persistedAuth = loadPersistedAuth();

const initialState: AuthState = persistedAuth;

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setCredentials: (
      state,
      action: PayloadAction<{ user: User; token: string; refreshToken: string | null }>
    ) => {
      const { user, token, refreshToken } = action.payload;
      state.user = user;
      state.token = token;
      state.refreshToken = refreshToken;
      state.isAuthenticated = true;
      persistAuth(user, token, refreshToken);
    },
    setAccessToken: (state, action: PayloadAction<string>) => {
      if (!state.user) {
        return;
      }

      state.token = action.payload;
      persistAuth(state.user, action.payload, state.refreshToken);
    },
    logout: (state) => {
      state.user = null;
      state.token = null;
      state.refreshToken = null;
      state.isAuthenticated = false;
      clearPersistedAuth();
    },
  },
});

export const { setCredentials, setAccessToken, logout } = authSlice.actions;
export default authSlice.reducer;
